import { filter, get, map } from 'lodash';
import { CSSProperties, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CropStateType, elementBeanListType } from '../../../Pages/Flo/Flo.types';
import { calculateAspectRatioFit } from '../../../utils/video.utils';
import { getBlurElementPosition } from '../../../Common/Common.utils';
import styles from './VideoSpotlights.module.css';
import SpotlightSvg from '../../../Common/Components/SpotlightSvg/SpotlightSvg';

const defaultBlurs: elementBeanListType[] = [];

const VideoSpotlights = ({
	currentTimeSeconds,
	videoSize = {
		width: 0,
		height: 0,
	},
	width: vWidth,
	height: vHeight,
	isCropped,
	appliedCrop,
	elementType,
	floIndex,
	stylesObj,
}: {
	currentTimeSeconds: number;
	videoSize?:
		| {
				width: number;
				height: number;
		  }
		| undefined
		| null;
	width: number;
	height: number;
	isCropped?: boolean;
	appliedCrop?: CropStateType;
	elementType?: string;
	floIndex: number;
	stylesObj?: CSSProperties;
}) => {
	const frameDims = calculateAspectRatioFit(
		get(videoSize, 'width', 0),
		get(videoSize, 'height', 0),
		vWidth,
		vHeight
	);
	const [spotlights, setSpotlights] = useState<elementBeanListType[]>([]);
	const offsetLeft = Math.abs(frameDims.width - vWidth) / 2;
	const offsetTop = (vHeight - frameDims.height) / 2;
	const elementsConfig: elementBeanListType[] = useSelector((state) =>
		get(state, `floPage.flos.${floIndex}.editorsElements.${elementType}`, defaultBlurs)
	);
	// const appliedCrop = useSelector((state) => {
	// 	return find(get(state, 'floPage.editorsElementsConfig'), [
	// 		'editorElementName',
	// 		'crop'
	// 	]);
	// })
	useEffect(() => {
		let spotlightElements = filter(
			elementsConfig,
			(element) =>
				// get(element, 'enabled') &&
				element.editorElementName === elementType &&
				currentTimeSeconds >= (get(element, 'time') ?? -1) &&
				currentTimeSeconds <= (get(element, 'endTime') ?? -1)
		);
		setSpotlights(
			map(spotlightElements, (i) => {
				let newElementObj = {
					id: get(i, 'id'),
					title: get(i, 'text'),
					enabled: get(i, 'enabled', true),
					startTime: get(i, 'time'),
					endTime: get(i, 'endTime'),
					intensity: get(i, 'intensity'),
					shape: get(i, 'shape'),
					canvasRenderConfig: get(i, 'canvasRenderConfig'),
					aspectRatio: get(i, 'aspectRatio') || get(i, 'canvasRenderConfig.aspectRatio'),
					points: {
						left: 0,
						top: 0,
						width: 0,
						height: 0,
					},
				};
				newElementObj = {
					...newElementObj,
					points: getBlurElementPosition({
						isCropped,
						appliedCrop,
						element: newElementObj,
						width: vWidth,
						height: vHeight,
						offsetHeight: offsetTop,
						offsetWidth: offsetLeft,
					}),
				};
				return newElementObj;
			})
		);
	}, [
		setSpotlights,
		elementsConfig,
		currentTimeSeconds,
		appliedCrop,
		isCropped,
		vWidth,
		vHeight,
		offsetTop,
		offsetLeft,
	]);

	return (
		<div
			style={{
				height: vHeight - offsetTop * 2,
				width: vWidth - offsetLeft * 2,
				...(stylesObj || {}),
			}}
			className={styles.wrapper}
		>
			<SpotlightSvg
				width={vWidth - offsetLeft * 2}
				height={vHeight - offsetTop * 2}
				spotlights={spotlights}
				id={`video_${floIndex}`}
			/>
		</div>
	);
};

export default VideoSpotlights;
